import React from "react";
import "../../../styles/About/Route/Experience.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons";
import { config } from "../../../data"; // ✅ make sure path is correct

const Experience = () => {
  const internships = config?.portfolio?.internships?.internship || [];

  return (
    <div className="experience">
      <div className="experience__container">
        {/* Header Section */}
        <div className="experience__header">
          <h2 className="experience__number">
            0<span>2</span>
          </h2>
          <h1 data-aos="fade-down" data-aos-offset="0">
            E<span>xperience</span>.
          </h1>
        </div>

        {/* Main Content */}
        <div className="experience__description">
          <div className="experience__main-box">
            {internships.map((exp, index) => (
              <div key={index} className="experience__box" data-aos="fade-up">
                <h2>{exp.companyName}</h2>
                <h3>
                  <FontAwesomeIcon
                    icon={faCalendarDays}
                    className="experience__calendar"
                  />
                  &nbsp;&nbsp;{exp.duration}
                </h3>
                {exp.role && <h4>{exp.role}</h4>}

                {/* Key Contributions */}
                <ul>
                  <p>Key Contributions:</p>
                  {[exp.keyPointOne, exp.keyPointTwo, exp.keyPointThree, exp.keyPointFour]
                    .filter(Boolean)
                    .map((point, i) => (
                      <li
                        key={i}
                        data-aos="fade-right"
                        data-aos-delay={200 * (i + 1)}
                      >
                        <span>{point}</span>
                      </li>
                    ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Experience;